"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const __enums_1 = require("../../../../__types/__enums");
const createReport_1 = require("../../../__common/createReport");
const getElasticsearchQueryFromFilters_1 = require("../../../__common/elasticsearchQuery/getElasticsearchQueryFromFilters");
const getElasticsearchSortForSortParams_1 = require("../../../__common/elasticsearchQuery/getElasticsearchSortForSortParams");
const reportHelpers_1 = require("../../../__common/reportHelpers");
const toFetchContentVersionLogsWithLearnerCount_1 = require("../../common/toFetchContentVersionLogsWithLearnerCount");
const versionLogsByQuery_1 = require("../../versionLogsByQuery");
const getContentVersionLogMetrics_1 = require("../common/getContentVersionLogMetrics");
function getPaginatedContentVersionLogReports(rp, input) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { ReportParams: reportParmas, ReportProjection = {} } = input;
        const { contentVersionLogProjection, relatedUserProjection } = ReportProjection;
        const { filters, from = 0, size = 100 } = reportParmas;
        const sortParams = input.SortParams;
        const query = getElasticsearchQueryFromFilters_1.getElasticsearchQueryForFilters(filters.contentVersionLogFilters);
        if (Object.keys(query.bool).length > 0) {
            const { contentVersionLogs, total } = yield versionLogsByQuery_1.getContentVersionLogsByQuery({
                requestType: __enums_1.ReportRequestTypeEnum.PAGINATED,
                _source: {},
                from,
                size,
                body: { query },
                sort: getElasticsearchSortForSortParams_1.getElasticsearchSortForSortParams(sortParams || [])
            });
            // const tempMetrics = projectedContentVersionLogs.map(doc => ({ contentId_versionId: doc._id }));
            // const contentVersionLogs = await getContentVersionLogs(rp, tempMetrics);
            // Fetching contentVersionLogMetrics corresponding to matching results
            if (relatedUserProjection) {
                yield reportHelpers_1.setRelatedUsers(rp, ReportProjection.relatedUserProjection, contentVersionLogs);
            }
            let contentVersionLogMetrics = [];
            if (toFetchContentVersionLogsWithLearnerCount_1.toFetchContentVersionLogsWithLearnerCount(contentVersionLogProjection)) {
                contentVersionLogMetrics = yield getContentVersionLogMetrics_1.getContentVersionLogMetrics(contentVersionLogs, filters.stateFilters);
            }
            return createReport_1.createContentVersionLogReport({ contentVersionLogMetrics, contentVersionLogs, total });
        }
        return createReport_1.createContentVersionLogReport({ contentVersionLogMetrics: [], contentVersionLogs: [], total: 0 });
    });
}
exports.getPaginatedContentVersionLogReports = getPaginatedContentVersionLogReports;
//# sourceMappingURL=index.js.map